define('type/article/Serum.Article.Note',['common/js/lib/util/loader'], function (Loader) {
  'use strict';

  var OPEN_NOTE_SELECTOR = 'nrkno-toggle[data-note]:not([hidden])';

  function initialize(el) {
    // Note: `span.note` are converted to `div.note-container`
    var notes = el.querySelectorAll('span.note');
    if (notes.length === 0) {
      return;
    }
    loadNrknoToggle();
    initializeNotes(notes);
  }

  function loadNrknoToggle() {
    Loader.loadJS('https://static.nrk.no/nrkno-toggle/major/1/nrkno-toggle-entry.js', {async: ''});
  }

  /**
  * @param {HTMLElement[]} notes
  */
  function initializeNotes(notes) {
    for (var i = 0; i < notes.length; i++) {
      var note = notes[i];
      var term = note.getAttribute('data-term') || '';
      var content = note.getAttribute('data-content') || '';
      var originalHtmlText = note.innerHTML;

      var container = document.createElement('div');
      container.setAttribute('class', 'note-container');
      var html = [
        '<button type="button" class="note-button">' + originalHtmlText + '</button>',
        '<nrkno-toggle data-note hidden data-popup value="ordforklaring for ' + term + '">',
        '<div class="note-content">',
        '<h3>' + term + '</h3>',
        content,
        '<button type="button" class="note-close" data-type="close" aria-label="Lukk ordforklaring">',
        '<svg data-type="close" aria-hidden="true" style="width:1.5em;height:1.5em"><use xlink:href="#nrk-close"></use></svg>',
        '</button>',
        '</div>',
        '</nrkno-toggle>'
      ].join('');

      container.innerHTML = html;
      container.addEventListener('click', handleNoteClick);
      container.addEventListener('toggle', centerNoteOnOpen);
      container.addEventListener('toggle', addCloseOnResizeListener);

      note.parentElement.replaceChild(container, note);
    }
  }

  function handleNoteClick(event) {
    var container = event.currentTarget;
    var element = event.target;
    if (typeof event.target.closest === 'function') {
      // NRKNO-4575: handle VoiceOver click targeting `<use>` element
      element = element.closest('[data-type]') || event.target
    }
    var type = element.getAttribute('data-type');
    if (!type) {
      return;
    }

    if (type === 'close') {
      var isActive = false;
      var shouldRefocus = true;
      changeActiveStatus(container, isActive, shouldRefocus);
    }
  }

  /**
  * Centers the `.note-content` element below the toggle button
  * @param {object} event nrkno-toggle event
  * @param {HTMLElement} event.target the `nrkno-toggle` element
  */
  function centerNoteOnOpen(event) {
    if (!isNrknoToggleEvent(event)) {
      return;
    }
    var nrknoToggle = event.target;


    /** @type {HTMLElement} */
    var content = nrknoToggle.querySelector('.note-content');
    if (nrknoToggle.hasAttribute('hidden')) {
      content.style.left = '';
      return;
    }

    var containerRect = nrknoToggle.parentElement.getBoundingClientRect();
    var screenInnerWidth = innerWidth;
    var containerCenterX = containerRect.right - containerRect.width / 2;
    var containerCenterXDistanceToRight = screenInnerWidth - containerCenterX;

    var contentRect = content.getBoundingClientRect();
    var padding = 10; // shadow*2
    var contentWidth = contentRect.width + padding;

    var contentCenterX = contentWidth / 2;
    var overflowingDiff = 0;
    if (containerCenterXDistanceToRight < contentCenterX) {
      // too close to right - can't center
      overflowingDiff = contentCenterX - containerCenterXDistanceToRight;
    }
    var containerAbsoluteCenter = containerRect.left + containerRect.width / 2;
    var centeredLeft = Math.max(padding / 2, containerAbsoluteCenter - contentCenterX - overflowingDiff);

    content.style.left = String(centeredLeft) + 'px';
  }


  /**
   * @param {HTMLElement} container
   * @param {boolean} isActive
   * @param {boolean} shouldRefocus
   */
  function changeActiveStatus(container, isActive, shouldRefocus) {
    var toggleElement = container.querySelector('nrkno-toggle');
    if (isActive) {
      toggleElement.removeAttribute('hidden');
    } else {
      toggleElement.setAttribute('hidden', '');
    }

    if (shouldRefocus) {
      var button = container.querySelector('.note-button');
      button.focus();
    }
  }

  /**
   * When a note is: opened - adds resize listener
   *                 closed - removes resize listener
   * The resize listener will close the open note (causing this listener to run again)
   */
  function addCloseOnResizeListener(event) {
    if (!isNrknoToggleEvent(event)) {
      return;
    }
    // Due to `popup` attribute - only 1 note can be open.
    var openNrknoToggle = document.querySelector(OPEN_NOTE_SELECTOR);
    if (openNrknoToggle) {
      window.addEventListener('resize', closeOpenNote);
    } else {
      window.removeEventListener('resize', closeOpenNote);
    }
  }

  function closeOpenNote() {
    var openNrknoToggle = document.querySelector(OPEN_NOTE_SELECTOR);
    var isActive = false;
    var shouldRefocus = false;
    changeActiveStatus(openNrknoToggle.parentElement, isActive, shouldRefocus);
  }

  // guard against core-toggle events sent from `/major/5/core-toggle`
  // core-toggle@5 has global event listeners
  function isNrknoToggleEvent(event) {
    return event.target.tagName === 'NRKNO-TOGGLE'
  }

  return {
    initialize: initialize
  };
});

